<template>
  <div class="animated fadeIn mt-3" id="report">
    <h1 class="text-uppercase font-weight-bold">Estadísticas Recepción</h1>
    <b-card id="element-to-hide" data-html2canvas-ignore="true">
      <b-row>
        <b-col sm="12" md="6" lg="3">
          <b-form-group label="Exportadora">
            <b-form-select
              size="sm"
              id="client_customer"
              v-model="client_customer"
              :options="client_customer_options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="3">
          <b-form-group label="Especie">
            <b-form-select size="sm" id="product" v-model="product" :options="product_options"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="3">
          <b-form-group label="Desde">
            <b-form-datepicker
              size="sm"
              placeholder="dd-mm-aaaa"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :max="maxDate"
              locale="es"
              v-model="from_date"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="3">
          <b-form-group label="Hasta">
            <b-form-datepicker
              size="sm"
              placeholder="dd-mm-aaaa"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es"
              :max="maxDate"
              v-model="to_date"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <kpis
        :from_date="from_date"
        :to_date="to_date"
        :client_customer="client_customer"
        :product="product"
        v-if="ready"
      />

      <b-row>
        <b-col>
          <b-card>
            <div class="chart-wrapper chart">
              <top-ten-growers
                chartId="chart-bar-02"
                :from_date="from_date"
                :to_date="to_date"
                :client_customer="client_customer"
                :product="product"
                v-if="ready"
              />
            </div>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <div class="chart-wrapper chart">
              <total-week
                chartId="totalWeekArrivals"
                :from_date="from_date"
                :to_date="to_date"
                :client_customer="client_customer"
                :product="product"
                v-if="ready"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="chart-wrapper chart">
              <total-variety
                chartId="totalVariety"
                :from_date="from_date"
                :to_date="to_date"
                :client_customer="client_customer"
                :product="product"
                v-if="ready"
              />
            </div>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <div class="chart-wrapper chart">
              <total-product-type
                chartId="totalProductType"
                :from_date="from_date"
                :to_date="to_date"
                :client_customer="client_customer"
                :product="product"
                v-if="ready"
              />
            </div>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <div class="chart-wrapper chart">
              <total-condition
                chartId="totalCondition"
                :from_date="from_date"
                :to_date="to_date"
                :client_customer="client_customer"
                :product="product"
                v-if="ready"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="chart-wrapper chart">
              <pallets-hours
                chartId="palletsHours"
                :from_date="from_date"
                :to_date="to_date"
                :client_customer="client_customer"
                :product="product"
                v-if="ready"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import TopTenGrowers from "./TopTenGrowers";
import TotalWeek from "./TotalWeek";
import TotalCondition from "./TotalCondition";
import TotalVariety from "./TotalVariety";
import TotalProductType from "./TotalProductType";
import PalletsHours from "./PalletsHours";
import Kpis from "./Kpis";
import html2pdf from "html2pdf.js";

export default {
  name: "charts",
  components: {
    TopTenGrowers,
    TotalWeek,
    TotalCondition,
    TotalVariety,
    PalletsHours,
    TotalProductType,
    Kpis
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th two months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 1);
    // 15th in two months
    const maxDate = new Date(today);

    return {
      ready: false,
      minDate: minDate,
      maxDate: maxDate,
      from_date: minDate.toISOString().split("T")[0],
      to_date: now.toISOString().split("T")[0],
      product: null,
      product_options: [],
      client_customer: null,
      client_customer_options: []
    };
  },
  watch: {
    client_customer(newVal, oldVal) {
      this.refreshData();
    },
    from_date(newVal, oldVal) {
      this.refreshData();
    },
    to_date(newVal, oldVal) {
      this.refreshData();
    },
    product(newVal, oldVal) {
      this.refreshData();
    }
  },
  methods: {
    downloadReport() {
      const element = document.getElementById("report");
      const opt = {
        margin: 0.5,
        image: { type: "jpeg", quality: 0.98 },
        filename: "Estadisticas Recepcion_" + this.from_date + "-" + this.to_date + ".pdf",
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "p" }
      };
      html2pdf().from(element).set(opt).save();
    },
    refreshData() {
      this.ready = false;
      this.$nextTick((_) => {
        this.ready = true;
      });
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.client_customer_options = customers;
          this.client_customer_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.product_options = products;
          this.product_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    }
  },
  async mounted() {
    this.loading = true;
    this.getCustomers();
    this.getProducts();
    this.ready = true;
  }
};
</script>

<style scoped>
.chart {
  max-height: 300px;
}
.card {
  border-radius: 10px;
}
</style>
